var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-form"},[_c('v-dynamic-form',{attrs:{"fields":_vm.fields,"initial-values":_vm.initialValues,"errors":_vm.formErrors},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }